import { Injectable } from '@angular/core';

import { Events, LocalStorage, Storage } from 'ionic-angular';

import { Location } from '../providers/location/location';

@Injectable()
export class UserData {
  _favorites = [];
  HAS_LOGGED_IN = 'hasLoggedIn';
  storage = new Storage(LocalStorage);

  constructor(public events: Events,public loc: Location) {}


  login(username) {
    this.storage.set(this.HAS_LOGGED_IN, true);
    this.setUsername(username);
    this.loc.startTracking(username);

 this.events.publish('user:login');
  }


  logout() {
    this.storage.remove(this.HAS_LOGGED_IN);
    this.storage.remove('username');
     this.events.publish('user:logout');
  }

  setUsername(username) {
    this.storage.set('username', username);
  }

  getUsername() {
    return this.storage.get('username').then((value) => {

this.loc.checkTracking(value);

      return value;
    });
  }

  hasLoggedIn() {


this.storage.get(this.HAS_LOGGED_IN).then((value) => {
      return value;
    });
  }
}
